import React from "react";
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel, HStack, Text, Icon, VStack, Skeleton, SkeletonText, SkeletonCircle } from "@chakra-ui/react";
import { FaHistory, FaUpload, FaComments } from "react-icons/fa";
import Logs from "../../../../../components/logs/Logs";
import Notes from "../../../../../components/notes/Notes";
import TicketAttachments from "./TicketAttachments";
import { useTranslation } from 'react-i18next';

export default function ActivityTabs({
  MotionBox,
  colorScheme,
  activeTab,
  handleTabChange,
  cardPadding,
  componentsLoading,
  setComponentLoading,
  ticketID,
  ticket,
  revalidator,
}) {
  const { t } = useTranslation();

  return (
    <MotionBox
      bg={colorScheme.cardBg}
      borderRadius="2xl"
      shadow="xl"
      border="1px solid"
      borderColor={colorScheme.borderColor}
      overflow="hidden"
      _hover={{ shadow: "2xl", transform: "translateY(-1px)" }}
      sx={{ transition: "all 0.3s ease" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.5 }}
    >
      <Tabs index={activeTab} onChange={handleTabChange} variant="enclosed" size="md">
        <TabList bg={colorScheme.cardBg} borderBottom="1px solid" borderColor={colorScheme.borderColor}>
          <Tab flex={1}>
            <HStack spacing={2}>
              <Icon as={FaHistory} boxSize={4} />
              <Text fontWeight="semibold">{t('ticket.activity_history')}</Text>
            </HStack>
          </Tab>
      
          <Tab flex={1}>
            <HStack spacing={2}>
              <Icon as={FaComments} boxSize={4} />
              <Text fontWeight="semibold">{t('notes')}</Text>
            </HStack>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={cardPadding}>
            {componentsLoading.logs ? (
              <VStack spacing={3} align="stretch">
                <HStack spacing={3}>
                  <SkeletonCircle size="6" />
                  <VStack align="start" spacing={1} flex={1}>
                    <Skeleton height="14px" width="60%" />
                    <Skeleton height="12px" width="40%" />
                  </VStack>
                  <Skeleton height="12px" width="80px" />
                </HStack>
                <HStack spacing={3}>
                  <SkeletonCircle size="6" />
                  <VStack align="start" spacing={1} flex={1}>
                    <Skeleton height="14px" width="70%" />
                    <Skeleton height="12px" width="50%" />
                  </VStack>
                  <Skeleton height="12px" width="80px" />
                </HStack>
              </VStack>
            ) : (
              <Logs subjectType="tickets" subjectID={ticketID} onLoadingChange={(loading) => setComponentLoading('logs', loading)} />
            )}
          </TabPanel>

        

          <TabPanel p={cardPadding}>
            {componentsLoading.notes ? (
              <VStack spacing={4} align="stretch">
                <HStack spacing={3}>
                  <SkeletonCircle size="8" />
                  <VStack align="start" spacing={2} flex={1}>
                    <Skeleton height="16px" width="30%" />
                    <SkeletonText noOfLines={3} spacing={2} />
                  </VStack>
                </HStack>
                <Skeleton height="100px" borderRadius="md" />
              </VStack>
            ) : (
              <Notes object_model="ticket.ticket" object_id={ticketID} revalidator={revalidator} onLoadingChange={(loading) => setComponentLoading('notes', loading)} />
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </MotionBox>
  );
}